import { LinearProgress, Stack, Typography } from "@mui/material";
import React from "react";
import useAlenSchedules from "src/services/alen/useAlenSchedules";
import { Floor } from "src/interfaces/IZone";
import { AlenDevice } from "src/interfaces/IAlenDevice";
import AddAlenScheduleButton from "./AddAlenSchedule";
import { AlenSchedulingProvider } from "./AlenSchedulingContext";
import AlenScheduleList from "./AlenScheduleList";

function AlenScheduling({
  alenPropertyId,
  propertyName,
  floors,
  alenDevices,
}: {
  alenPropertyId: number;
  propertyName: string;
  floors: Floor[];
  alenDevices: AlenDevice[];
}) {
  const { isLoading, data, error, refetch } = useAlenSchedules(alenPropertyId);

  return (
    <Stack
      direction="column"
      paddingY="1rem"
      gap="1rem"
      alignItems="flex-start"
    >
      <AlenSchedulingProvider
        alenPropertyId={alenPropertyId}
        propertyName={propertyName}
        floors={floors}
        devices={alenDevices}
      >
        <AddAlenScheduleButton onCreated={refetch} />

        {isLoading && <LinearProgress />}
        {error && <Typography>{error.message}</Typography>}
        {data && <AlenScheduleList schedules={data} onStatusChange={refetch} />}
      </AlenSchedulingProvider>
    </Stack>
  );
}

export default AlenScheduling;
